import React, { useCallback } from "react";
import {
  FaSearch,
  FaRedo,
  FaFileDownload,
  FaLock,
  FaLockOpen,
} from "react-icons/fa";
import Button from "../../../components/Button/Button";
import Select from "../../../components/Select/SearchableSelect";
import Input from "../../../components/Input/Input";

const StudentFilter = ({
  type = "student", // 'student' | 'activation'
  programList = [],
  filters,
  setFilters,
  onSearch,
  onReset,
  onGenerateKey, // only for activation key page
  onToggleEditMode, // only for student list page
  onDownload, // only for student list page
  isSearching,
  isEditMode, // only for student list page
}) => {
  const onChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      setFilters((prev) => ({ ...prev, [name]: value }));
    },
    [setFilters],
  );

  return (
    <div className="student-filter-bar">
      <div className="row">
        {/* Class */}
        <div className="col-md-6">
          <Select
            name="programId"
            value={filters.programId}
            onChangeHandler={onChange}
            options={programList}
            placeholder="Select Class"
          />
        </div>

        {/* Admission No */}
        <div className="col-md-6">
          <Input
            type="text"
            name="idNumber"
            value={filters.idNumber}
            placeholder="Search by Admission..."
            onChangeHandler={onChange}
          />
        </div>

        {/* Name */}
        <div className="col-md-6">
          <Input
            type="text"
            name="name"
            value={filters.name}
            placeholder="Search by first name..."
            onChangeHandler={onChange}
          />
        </div>

        {/* Actions */}
        <div className="col-md-6">
          <Button variant="success" onClick={onSearch}>
            <FaSearch /> Search
          </Button>

          <Button variant="secondary" className="mx-1" onClick={onReset}>
            <FaRedo /> Reset
          </Button>

          {/* Student List specific buttons */}
          {type === "student" && isSearching && filters.programId && (
            <>
              <Button
                variant={isEditMode ? "secondary" : "primary"}
                onClick={onToggleEditMode}
              >
                {isEditMode ? <FaLock /> : <FaLockOpen />}
                {isEditMode ? "Edit Mode OFF" : "Edit Mode ON"}
              </Button>

              <Button variant="primary" className="mx-1" onClick={onDownload}>
                <FaFileDownload /> Download
              </Button>
            </>
          )}

          {/* Activation Key specific button */}
          {type === "activation" && (
            <Button variant="secondary" onClick={onGenerateKey}>
              Generate
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(StudentFilter);
